import { useEffect, useState } from 'react'

const CARDS = [
  {
    kicker: 'Agents',
    title: 'Connect MCP',
    command: "Add your instance's MCP server in Claude, ChatGPT, or Cursor",
    links: [
      { kind: 'docs', href: 'https://docs.omni.co/ai/mcp', label: 'docs' },
    ],
  },
  {
    kicker: 'Editor',
    title: 'Install the agent skills',
    command: '/plugin marketplace add exploreomni/omni-agent-skills',
    copyable: true,
    links: [
      {
        kind: 'docs',
        href: 'https://docs.omni.co/developers/agent-skills',
        label: 'docs',
      },
      {
        kind: 'github',
        href: 'https://github.com/exploreomni/omni-agent-skills',
        label: 'github',
      },
    ],
  },
  {
    kicker: 'Terminal',
    title: 'Install the CLI',
    command:
      'curl -fsSL https://raw.githubusercontent.com/exploreomni/cli/main/install.sh | sh',
    copyable: true,
    links: [
      {
        kind: 'docs',
        href: 'https://docs.omni.co/developers/cli',
        label: 'docs',
      },
      {
        kind: 'github',
        href: 'https://github.com/exploreomni/cli',
        label: 'github',
      },
    ],
  },
]

/** Copies the card's command to the clipboard; the icon turns into a check for a moment. */
const CopyButton = ({ text }: { text: string }) => {
  const [done, setDone] = useState(false)
  useEffect(() => {
    if (!done) return
    const t = setTimeout(() => setDone(false), 1500)
    return () => clearTimeout(t)
  }, [done])
  return (
    <button
      className={done ? 'copy copy--done' : 'copy'}
      type="button"
      aria-label={done ? 'Copied' : 'Copy command'}
      onClick={() => {
        navigator.clipboard
          ?.writeText(text)
          .then(() => setDone(true))
          .catch(() => undefined)
      }}
    >
      <svg className="copy__icon" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z" />
        <path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z" />
      </svg>
      <svg className="copy__check" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z" />
      </svg>
    </button>
  )
}

/** Three setup cards with one real step each; the close band below carries the calls to action. */
export const Setup = () => (
  <section
    className="page-section page-section--lg developers-setup"
    id="start"
  >
    <div className="page-section__inner">
      <hgroup className="developers-setup__head">
        <h2 className="heading-xl text-brand-dark">Setup is easy</h2>
      </hgroup>
      <div className="developers-setup__grid">
        {CARDS.map((card) => (
          <article className="doorc" key={card.title}>
            <p className="doorc__kicker caps-xxs">{card.kicker}</p>
            <h3 className="heading-s text-brand-dark">{card.title}</h3>
            <pre>
              {card.command}
              {card.copyable && <CopyButton text={card.command} />}
            </pre>
            <div className="t-links">
              {card.links.map((link) => (
                <a
                  className={`t-link k-${link.kind}`}
                  href={link.href}
                  key={link.href}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)
